import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { GetApiVersionRequest, GetApiVersionResponse } from '../models/version.models';

@Injectable({
  providedIn: 'root'
})
export class VersionService {
  private apiUrl: string;

  constructor(private http: HttpClient, private configService: ConfigService, private authService: AuthService) {
    this.apiUrl = `${this.configService.getConfig().apiBaseUrl}/ApiVersion`;
  }

  private getHeaders(): HttpHeaders {
    const token = this.authService.getToken();
    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
  }

  GetApiVersion(request: GetApiVersionRequest): Observable<GetApiVersionResponse> {
    return this.http.get<GetApiVersionResponse>(`${this.apiUrl}/get-api-version`, {
      headers: this.getHeaders(),
      params: request as any
    });
  }
}